import { render, staticRenderFns } from "./TrustedThirdPartyAuthView.vue?vue&type=template&id=a6186d4e&scoped=true"
import script from "./TrustedThirdPartyAuthView.vue?vue&type=script&lang=js"
export * from "./TrustedThirdPartyAuthView.vue?vue&type=script&lang=js"
import style0 from "./TrustedThirdPartyAuthView.vue?vue&type=style&index=0&id=a6186d4e&prod&lang=scss&scoped=true"
import style1 from "./TrustedThirdPartyAuthView.vue?vue&type=style&index=1&id=a6186d4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6186d4e",
  null
  
)

export default component.exports